/*
 * @Author: chenchaoqiang@leedarson.com
 * @Date: 2022-08-03 10:40:10
 * Copyright 2022 Leedarson, All Rights Reserved.
 */

import { IOrderCreateData } from '@root/types/order';
import { http } from '@shared';

// 获取租户 IOS 套餐
const getPackages = () => {
  return http.request({
    url: '/api/ipc/ApplePay/goodsPage',
    params: {
      pageNum: 1,
      pageSize: 100,
    },
  });
};

// IOS 套餐 创建订单
const createOrder = (data: IOrderCreateData) => {
  return http.request({
    url: '/api/ipc/ApplePay/order',
    method: 'POST',
    data,
  });
};

const checkCanSubscribe = () => {
  return http.request({
    url: '/api/ipc/ApplePay/checkCanSubscribe',
  });
};

export { getPackages, createOrder, checkCanSubscribe };
